import Model from "./Concerns/Model";

export default class SampleConfiguration extends Model {
    min_elements!: number;
    max_elements!: number;
    min_samples!: number;
    max_samples!: number;

    getTable(): string {
        return 'sample_configurations';
    }
}
